import React, { useId } from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  variant?: 'dark' | 'light';
}
export function Input({
  className = '',
  label,
  error,
  id,
  variant = 'dark',
  ...props
}: InputProps) {
  const inputId = id || useId();
  const variants = {
    dark: {
      label: 'text-white/90',
      input: 'border-white/20 bg-white/10 text-white placeholder:text-white/60 focus-visible:ring-white/50',
      error: 'text-red-200'
    },
    light: {
      label: 'text-teal',
      input: 'border-sage/30 bg-white text-teal placeholder:text-teal/40 focus-visible:ring-sage focus-visible:border-sage',
      error: 'text-red-500'
    }
  };
  const styles = variants[variant];
  return <div className="w-full" data-id="element-195">
      {label && <label htmlFor={inputId} className={`mb-2 block text-sm font-medium ${styles.label}`} data-id="element-196">
          {label}
        </label>}
      <input id={inputId} className={`flex h-12 w-full rounded-lg border px-4 py-2 focus-visible:outline-none focus-visible:ring-2 disabled:cursor-not-allowed disabled:opacity-50 transition-colors ${styles.input} ${error ? 'border-red-300 focus-visible:ring-red-300' : ''} ${className}`} {...props} data-id="element-197" />
      {error && <p className={`mt-1 text-sm ${styles.error}`} data-id="element-198">{error}</p>}
    </div>;
}